// Calculated based off of https://www.w3.org/TR/WCAG20-TECHS/G17.html

const rc = 0.2126;
const gc = 0.7152;
const bc = 0.0722;

const threshold = 0.03928;
const dividend = 12.92;

export function verfiyContrastRatioThresholds(
  colorAndThresholdSet: {
    color1?: string;
    color1Label?: string;
    color2?: string;
    color2Label?: string;
    threshold: number;
  }[]
): string[] {
  const errors: string[] = [];

  colorAndThresholdSet.forEach((entry) => {
    if (!entry.color1 || !entry.color2) {
      return;
    }

    try {
      const ratio = contrastRatio(rgbFromCssString(entry.color1), rgbFromCssString(entry.color2));
      if (ratio < entry.threshold) {
        errors.push('Insufficient contrast ratio (' + ratio + '): ' + JSON.stringify(entry));
      }
    } catch (error) {
      errors.push('Error getting contrast ratio of colors: ' + JSON.stringify(entry));
    }
  });

  return errors;
}

export function luminance(rgb: number[]): number {
  rgbVerify(rgb);

  return luminanceInternal(rgb);
}

export function contrastRatio(rgb1: number[], rgb2: number[]): number {
  rgbVerify(rgb1);
  rgbVerify(rgb2);

  const l1 = luminanceInternal(rgb1) + 0.05;
  const l2 = luminanceInternal(rgb2) + 0.05;

  return l1 > l2 ? l1 / l2 : l2 / l1;
}

export function rgbFromCssString(color: string): number[] {
  const element = document.createElement('div');
  element.style.color = color;

  const rgbMatch = element.style.color.match(
    /^rgb(?:a)?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*\d+(?:\.\d+)?\s*)?\)/i
  );

  if (rgbMatch) {
    const resolvedColor = [
      parseInt(rgbMatch[1], /* radix */ 10),
      parseInt(rgbMatch[2], /* radix */ 10),
      parseInt(rgbMatch[3], /* radix */ 10)
    ];
    rgbVerify(resolvedColor);
    return resolvedColor;
  }

  throw new Error('Can not parse color string: ' + color);
}

function luminanceInternal(rgb: number[]): number {
  const rs = rgb[0] / 255;
  const gs = rgb[1] / 255;
  const bs = rgb[2] / 255;

  const rl = rs <= threshold ? rs / dividend : adjustColor(rs);
  const gl = gs <= threshold ? gs / dividend : adjustColor(gs);
  const bl = bs <= threshold ? bs / dividend : adjustColor(bs);

  return rc * rl + gc * gl + bc * bl;
}

function rgbVerify(rgb: number[]) {
  if (rgb.length < 3) {
    throw new Error('The color array should have a length of at least 3');
  }

  for (let i = 0; i < 3; i += 1) {
    if (!Number.isInteger(rgb[i])) {
      throw new Error('The color value should be an integer: ' + rgb[i]);
    }
    if (rgb[i] < 0) {
      throw new Error('The color value should be greater or equal than 0: ' + rgb[i]);
    }
    if (rgb[i] > 255) {
      throw new Error('The color value should be lesser or equal than 255: ' + rgb[i]);
    }
  }
}

function adjustColor(colorIndex: number): number {
  return Math.pow((colorIndex + 0.055) / 1.055, 2.4);
}
